import { createFileRoute } from "@tanstack/react-router";
import DepressionTreatmentOptions from "@/pages/DepressionTreatmentOptions";
export const Route = createFileRoute("/depression-treatment-options")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Treatment Options | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Compare depression treatment options: TMS, SAINT TMS, SPRAVATO, ketamine, medication, and therapy in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Depression Treatment Options | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Compare depression treatment options: TMS, SAINT TMS, SPRAVATO, ketamine, medication, and therapy in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/depression-treatment-options",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-treatment-options",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionTreatmentOptions />;
}
